import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { StyledPanel } from 'src/components/StyledPanel';

interface Props {
  organizationName: string;
  period: string;
  createdAt?: string;
  withoutExtrapolation: boolean;
  canDelete: boolean;
  onDeleteclick: () => void;
}

export default function SurveyInfoSection(props: Props) {
  const { t } = useTranslation('ghg');
  const {
    organizationName,
    period,
    createdAt,
    withoutExtrapolation,
    canDelete,
    onDeleteclick,
  } = props;

  return (
    <StyledPanel>
      <Typography variant="h5" gutterBottom>
        {t('employeeSurveys.detail.title')}
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: 2,
        }}
      >
        <Box>
          <Typography variant="body2" color="text.secondary">
            {t('employeeSurveys.previewTable.columns.organizationName')}
          </Typography>
          <Typography variant="body1" fontWeight="medium">
            {organizationName}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2" color="text.secondary">
            {t('employeeSurveys.previewTable.columns.period')}
          </Typography>
          <Typography variant="body1" fontWeight="medium">
            {period}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2" color="text.secondary">
            {t('employeeSurveys.previewTable.columns.createdAt')}
          </Typography>
          <Typography variant="body1" fontWeight="medium">
            {createdAt ? new Date(createdAt).toLocaleDateString() : 'N/A'}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2" color="text.secondary">
            {t('employeeSurveys.previewTable.columns.withoutExtrapolation')}
          </Typography>
          <Typography variant="body1" fontWeight="medium">
            {withoutExtrapolation
              ? t('employeeSurveys.previewTable.states.extrapolation.yes')
              : t('employeeSurveys.previewTable.states.extrapolation.no')}
          </Typography>
        </Box>
      </Box>
      {canDelete && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            startIcon={<DeleteIcon />}
            onClick={onDeleteclick}
          >
            {t('employeeSurveys.detail.delete')}
          </Button>
        </Box>
      )}
    </StyledPanel>
  );
}
